import React, { useContext } from "react";
import { Link } from "react-router-dom";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrashCan } from '@fortawesome/free-solid-svg-icons';

import { EntitiesContext } from "../../../App";
import { useDeleteSale } from "../../../hooks/useSale";

export default function SalesList() {
  const entities = useContext(EntitiesContext);
  const sales = entities.state.get('sale')
  const deleteSale = useDeleteSale()

  // const handleEditClick = () => {
  // Function to edit the data for this row
  // };

  const handleDeleteClick = (sale) => {
    deleteSale.mutate(sale)
  };

  // const editIcon = <FontAwesomeIcon icon={faPencil} />
  const trashIcon = <FontAwesomeIcon icon={faTrashCan} />

  // return a table of sales
  return (
    <div className="table-container">
        <table className="table is-fullwidth is-hoverable">
          <thead>
            <tr>
              <th>Start Date</th>
              <th>End Date</th>
              <th>Consignment Start</th>
              <th>Consignment End</th>
              {/* <th>
  <span className="icon is-small">
    {editIcon}
  </span>
</th> */}
              <th>
                <span className="icon is-small">
                  {trashIcon}
                </span>
              </th>
            </tr>
          </thead>
          <tbody>
            {sales.valueSeq().map(s => <tr key={s.id}>
              <td>{s.sale_start}</td>
              <td>{s.sale_end}</td>
              <td>{s.consignment_start}</td>
              <td>{s.consignment_end}</td>
              {/* <td><button className="button is-success is-outlined" onClick={handleEditClick}>
      <span className="icon is-small">
        {editIcon}
      </span>
    </button>
    </td> */}
              <td>
                <button className="button is-danger is-outlined" onClick={() => handleDeleteClick(s)} disabled={deleteSale.isLoading}>
                  <span className="icon">
                    {trashIcon}
                  </span>
                </button>
              </td>
              {/* <td><button className="button is-danger" onClick={handleDeleteClick}>Delete</button></td> */}

            </tr>)}
          </tbody>
          <tfoot>
          </tfoot>
        </table>
    </div>
  )
}
